type SearchDialogShortcutEvent = Pick<KeyboardEvent, "ctrlKey" | "metaKey"> & {
  key?: unknown;
};

export const isSearchDialogShortcut = (event: SearchDialogShortcutEvent) => {
  if (!event.metaKey && !event.ctrlKey) {
    return false;
  }

  return typeof event.key === "string" && event.key.toLowerCase() === "k";
};
